import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Observe styles before bootstrapping so a load/error during bootstrap is captured.
const stylesReady = Promise.all(
  Array.from(document.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]')).map(
    (stylesheet) => new Promise<void>((resolve) => {
      if (stylesheet.sheet || document.readyState === 'complete') {
        resolve();
        return;
      }
      stylesheet.addEventListener('load', () => resolve(), { once: true });
      stylesheet.addEventListener('error', () => resolve(), { once: true });
    }),
  ),
);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(async () => {
    await stylesReady;
    // Route components own their loading state; unrelated tasks and images must
    // not keep the whole application hidden after its initial view is created.
    document.body.classList.remove('app-loading');
    console.info('MFA_PERF browser_stage', {
      stage: 'document_to_app_shell',
      outcome: 'completed',
      durationMs: Math.round(performance.now() * 100) / 100,
    });
  })
  .catch((err) => console.error(err));
